var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-btn",class:_vm.active? 'active': '',on:{"click":function($event){_vm.active? _vm.$emit('clicked'): {}}}},[_vm._v(_vm._s(_vm.$t(`btn.${_vm.type}`))),_c('div',{staticClass:"notice"},[_vm._v(_vm._s(_vm.notice))])])
}
var staticRenderFns = []

export { render, staticRenderFns }